import EventEmitter from "events"

const Events = new EventEmitter()

export default Events

export const EVENT_TYPES = Object.freeze({
  menu: "menu"
})
